import React from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'

function ProductionStatisticsBySewingPartnerTable(props) {
    const { statisticData = [], formatRate } = props

    return (
        <div className="ProductionStatisticsBySewingPartnerTable">
            <table className="table table-bordered">
                <thead
                    style={{
                        background: '#0f9d58',
                        color: '#fff',
                        fontStyle: 'normal',
                        fontWeight: 300,
                        fontSize: '16px',
                        textAlign: 'center',
                    }}
                >
                    <tr>
                        <th>Partner may</th>
                        <th>Tổng số lượng đẩy</th>
                        <th>Tổng số lượng tồn kho</th>
                        <th>Tổng số lượng đã may</th>
                        <th>Tổng số lượng đúng hạn</th>
                        <th>Tổng số lượng quá hạn</th>
                        <th>Tỉ lệ quá hạn (%)</th>
                        <th>Số lượng lỗi</th>
                        <th>Tỉ lệ lỗi (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(statisticData) && statisticData.length > 0 ? (
                        statisticData.map((item, index) => {
                            const {
                                partner = '',
                                total = 0,
                                inProgress = 0,
                                received = 0,
                                onTime = 0,
                                late = 0,
                                error = 0,
                            } = item || {}

                            return (
                                <tr key={`${partner}-${index}`}>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{partner}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{total}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{inProgress}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{received}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{onTime}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{late}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>
                                        {formatRate(late, total)}
                                    </td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>{error}</td>
                                    <td style={{ fontWeight: 600, textAlign: 'center' }}>
                                        {formatRate(error, total)}
                                    </td>
                                </tr>
                            )
                        })
                    ) : (
                        <tr>
                            <td colSpan={9}>
                                <Empty description="Không có dữ liệu" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

ProductionStatisticsBySewingPartnerTable.propTypes = {
    statisticData: PropTypes.array,
}

export default ProductionStatisticsBySewingPartnerTable